
import { FetchContent } from '../';
import FastXmlParser from 'fast-xml-parser';
import { type DocsCMS } from '../types/api-docs';
import { type CmsType } from '../types/common';

async function GetAPIDocs(cmsFor: CmsType): Promise<DocsCMS> {
    const xmlContent = await FetchContent(cmsFor);
    var jsonContent = {};
    if (FastXmlParser.validate(xmlContent) === true) {
        jsonContent = FastXmlParser.parse(xmlContent);
    }
    return await jsonContent;
}
export default GetAPIDocs;
